import { render, staticRenderFns } from "./iptalPolitikalari.vue?vue&type=template&id=0bd48d1a&"
import script from "./iptalPolitikalari.vue?vue&type=script&lang=js&"
export * from "./iptalPolitikalari.vue?vue&type=script&lang=js&"
import style0 from "./iptalPolitikalari.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports